import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { passwordLoginRequirementParser, ssoLoginRequirementParser, } from '#validation';
import { SsoLoginParamsResponseSchema } from '#web-service-api/sso';
const UserLoginConfigBaseSchema = z.object({
    passwordLoginRequirement: passwordLoginRequirementParser,
    ssoLoginRequirement: ssoLoginRequirementParser,
    ssoLoginParams: SsoLoginParamsResponseSchema.nullable(),
});
/**
 * @deprecated
 *
 * Use: UserLoginConfigResponseDto instead
 *
 * Date: 17.12.25
 */
export const UserLoginConfigDeprecatedSchema = UserLoginConfigBaseSchema;
/**
 * @deprecated
 *
 * Use: UserLoginConfigResponseDto instead
 *
 * Date: 17.12.25
 */
export class UserLoginConfigDeprecatedResponseDto extends createZodDto(UserLoginConfigDeprecatedSchema) {
}
export const UserLoginConfigSchema = UserLoginConfigBaseSchema.extend({
    isWorkspaceNameRequired: z.boolean(),
    workspaceId: z.string().nullable(),
});
export class UserLoginConfigResponseDto extends createZodDto(UserLoginConfigSchema) {
}
